import React from 'react'
import { useParams } from 'react-router'
import MentorEventTypes from 'src/supportPortal/components/common/mentor/eventTypes/MentorEventTypes'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'

export default function DoctorsEventTypes() {
  const { mentorSlug } = useParams()
  return (
    <MentorEventTypes
      mentorSlug={mentorSlug}
      fetchSingleMentorSignature={`/api/secure/cc/support/doctor/by-slug`}
      saveOneOnOnePlanApiSignature={`/api/secure/cc/support/1on1-custom-plan`}
      fetchMentorClinicAssociationsSignature={`/api/secure/cc/support/doctor/clinic-associations`}
      forDoctor
    />
  )
}
